import Footer from 'components/global/footer'
import DigitalBilboards from 'components/inventory/DigitalBilboards'
import Hero from 'components/inventory/Hero'
import PlaceBased from 'components/inventory/PlaceBased'
import StreetFurniture from 'components/inventory/StreetFurniture'
import Transit from 'components/inventory/Transit'

const Inventory = () => {

    return (
        <div>
            <Hero />
            <DigitalBilboards />
            <PlaceBased />
            <StreetFurniture />
            <Transit />
            <Footer />
        </div>
    )
}

export default Inventory